import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    customerInfo: null,
    newMacDetected: false,
    cashTotals: {}
  },
  mutations: {
    loginSuccess (state, newCustomerInfo) {
      state.customerInfo = newCustomerInfo
    },
    loginFailure (state) {
      state.customerInfo = null
    },
    logout (state) {
      state.customerInfo = null
    },
    newMacDetected (state, newMac) {
      state.newMacDetected = newMac
      if (newMac === false) {
        document.cookie = 'RD-new-MAC-detected=; max-age=0; path=/;'
      }
    },
    setCashTotals (state, newTotals) {
      state.cashTotals = newTotals
    }
  }
})



// WEBPACK FOOTER //
// ./src/vuex-store.js